export default "__VITE_ASSET__b2c7fc97__"